module.exports = __webpack_public_path__ + "img/prof.b545e9db.png";